import confetti from 'canvas-confetti'
import store from './store/index.js'

export default function (data) {
  const animationLength = data.seconds || 3;
  const end = Date.now() + (animationLength * 1000);
  const colors = [store.state.dog.lead_color, store.state.dog.supporting_color];
  (function frame() {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors
    });
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors
    });
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  }());

  if (data.message) {
    store.dispatch('setConfettiMessage', data.message)
    setTimeout(() => {
      store.dispatch('setConfettiMessage', '')
    }, 15000);
  }
}
